import { analiticaInstance } from 'shared/analitica'

import { type Analytics } from '~/domains/home-v2/types'

export default analiticaInstance.eventFactory('Header', {
  dropDownMenu: {
    /**
     * @analitica When the user click on drop-down menu
     */
    click: (analytics: Analytics) => ({
      label: analytics?.eventName,
      metadata: {
        type: analytics.type,
        properties: analytics?.properties
      }
    })
  },
  header: {
    clickOnLogo: () => ({
      label: 'button-clicked',
      metadata: {
        owner: 'home',
        product: 'home',
        screen: 'home',
        project: 'stone',
        reference: 'Ocultar saldo',
        button_id: 'stone_logo'
      }
    })
  }
})
